import { useRef, useState } from 'react';
import { View, useWindowDimensions } from 'react-native';
import { useSafeAreaInsets } from 'react-native-safe-area-context';

import { BOTTOM_TABS_HEIGHT } from '@/components/TabBar';
import { Text } from '@/components/TextComponent';
import { Box } from '@/components/lib/components';

type NoMarketsMessageProps = {
    message: string;
};

export const NoMarketsMessage = ({ message }: NoMarketsMessageProps) => {
    const ref = useRef<View>(null);
    const { height } = useWindowDimensions();
    const insets = useSafeAreaInsets();
    const [top, setTop] = useState<number>();
    // fills from where the line starts down to the tab bar, so the copy centres in the space left on screen
    const minHeight = top === undefined ? undefined : height - insets.bottom - BOTTOM_TABS_HEIGHT - top;
    const shouldDisplayMessage = top !== undefined;

    return (
        <Box
            ref={ref}
            onLayout={() => ref.current?.measureInWindow((_x, y) => setTop(y))}
            minHeight={minHeight}
            py="s64"
            px="s40"
            justifyContent="center"
            alignItems="center"
        >
            <Text variant="titleLarge" letterSpacing={-0.43} textAlign="center">
                {shouldDisplayMessage ? message : ''}
            </Text>
        </Box>
    );
};
